<template>
    <div class="flex flex-column">
        <div class="flex align-items-center justify-between">
            <div>
                <p class="mb-0">{{ status }}</p>
                <small ref="success_employer_email" class="d-none text-success mt-1">sdf</small>
            </div>
            <button @click="toggle_input()" onclick="this.blur()" class="btn btn-sm btn-primary"><i ref="toggle_input_button_icon" class="fas fa-paper-plane"></i></button>
        </div>
        <div ref="input_wrap" class="flex justify-between align-items-end mt-2 border-top border-primary toggle-email-input">
            <div class="form-group w-100 mb-0 mr-2 pt-2">
                <small ref="error_employer_email" class="text-danger"></small>
                <input v-model="employer_email" ref="input_employer_email" class="form-control mt-1" style="min-width: 200px" type="text" name="employer_email" placeholder="E-mail werkgever">
            </div>
            <button @click="send_new_mail()" onclick="this.blur()" class="btn btn-sm btn-secondary" style="margin-bottom: 0.2rem !important"><i class="fas fa-paper-plane"></i></button>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                status: '',
                employer_email: ''
            }
        },
        props: {
            item_kind: '',
            item: {},
            item_statuses: {},
        },
        mounted() {
            if(this.item_kind === 'absence')
            {
                this.status = this.item_statuses['MailSent'] === this.item['status'] ? 'Verstuurd' : 'Niet verstuurd';
            }
            else
            {
                console.log(this.item_statuses);
                this.status = this.item_statuses['MailVerstuurd'] === this.item['status'] ? 'Verstuurd' : 'Niet verstuurd';
            }
        },
        methods: {
            toggle_input: function() {
                this.$refs['input_wrap'].classList.toggle('toggle-email-input--show');
                this.$refs['input_wrap'].classList.remove('toggle-email-input--with-error');
                this.$refs['input_employer_email'].classList.remove('is-invalid');
                this.$refs['error_employer_email'].innerHTML = '';

                this.$refs['toggle_input_button_icon'].classList.toggle('fa-arrow-down');
                this.$refs['toggle_input_button_icon'].classList.toggle('fa-arrow-up');

                if(typeof this.$parent.set_tables_wrap_height === 'function')
                {
                    this.$parent.set_tables_wrap_height();
                }

            },
            send_new_mail: function() {
                if(this.validate_email(this.employer_email))
                {
                    this.$refs['input_wrap'].classList.remove('toggle-email-input--with-error');
                    this.$refs['input_wrap'].classList.remove('toggle-email-input--show');
                    this.$refs['toggle_input_button_icon'].classList.add('fa-arrow-down');
                    this.$refs['toggle_input_button_icon'].classList.remove('fa-arrow-up');
                    this.$refs['input_employer_email'].classList.remove('is-invalid');
                    this.$refs['error_employer_email'].innerHTML = '';
                    this.$refs['success_employer_email'].classList.add('d-inline-block');
                    this.$refs['success_employer_email'].classList.remove('d-none');
                    this.$refs['success_employer_email'].innerHTML = 'E-mail is verstuurd';

                    this.status = 'Verstuurd';

                    let axios = require('axios');
                    console.log(this.item_kind);
                    if(this.item_kind === 'worked_time')
                    {
                        axios.post('/employee/worked-times/send-new-mail', {
                            item_id: this.item.id,
                            employer_email: this.employer_email
                        }).then(() => {
                            this.employer_email = '';
                        });
                    }
                    else if(this.item_kind === 'overwork_time')
                    {
                        axios.post('/employee/overwork-times/send-new-mail', {
                            item_id: this.item.id,
                            employer_email: this.employer_email
                        }).then(() => {
                            this.employer_email = '';
                        });
                    }
                    else if(this.item_kind === 'sick_leave')
                    {
                        axios.post('/employee/sick-leaves/send-new-mail', {
                            item_id: this.item.id,
                            employer_email: this.employer_email
                        }).then(() => {
                            this.employer_email = '';
                        });
                    }
                    //toegevoegd dimer, geeft na refresh ook niet aan mail verzonden en werkt dus nog niet Kevin naar kijken.
                    else if(this.item_kind === 'absence')
                    {
                        axios.post('/employee/absences/send-new-mail', {
                            item_id: this.item.id,
                            employer_email: this.employer_email
                        }).then(() => {
                            this.employer_email = '';
                        });
                    }
                }
                else
                {
                    this.$refs['input_wrap'].classList.add('toggle-email-input--with-error');
                    this.$refs['input_employer_email'].classList.add('is-invalid');
                    this.$refs['error_employer_email'].innerHTML = 'Ongeldig e-mailadres';
                    this.$refs['success_employer_email'].classList.add('d-none');
                    this.$refs['success_employer_email'].classList.remove('d-inline-block');
                    this.$refs['success_employer_email'].innerHTML = '';
                }
                if(typeof this.$parent.set_tables_wrap_height === 'function')
                {
                    this.$parent.set_tables_wrap_height();
                }
            },
            validate_email: function(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        }
    }
</script>
